import Custa  from "@/entities/Custas/Custa"
import SeloItemOs  from "@/entities/SeloItemOs/SeloItemOs"
import store from '@/store/index'
import PapelSegurancaLoteItensService from "@/services/PapelSeguranca/PapelSegurancaLoteItensService"



class OrdemServicoItem {
  constructor (data) {
    // DB
    this.ordem_servico_item_id = null
    this.custa_id = null
    this.ordem_servico_id = null
    this.custa = new Custa()
    this.seloItemOs = []
    this.registro_id = null
    this.descricao = null
    this._valor = 0
    this.quantidade = 1
    this.averbacao = 0
    this.flag_cancelado = false
    this.created_at = null
    this.updated_at = null

    // Estados para manipualação front
    this.valorFinal = null
    this.seloStatus = false,
    this.impressosSeguranca = false
    this.seloDuplo = false
    this.zerarCusta = false
    this.excluirSelo = false
    this.cancelarSelo = false
    this.tipo_registro = null

    this.papeisDisponiveis = []
    this.papeisSelecionados = []
    
    if (data) this.__init(data)
  }
  __init (data) {
    Object.assign(this, data)
    
    if (data.custa) {
      this.custa = new Custa(data.custa)
    }
    if (data.seloItemOs.length) {
      this.seloItemOs = data.seloItemOs.map((item) => new SeloItemOs(item))
    }
    if (data.valor >= 0) this.valorFinal = data.valor

  }
 // Getters e setters
  setCusta (custa, tipoRegistro) {
    
    if (custa.tipo_ato) {
      this.seloStatus = true
    } else this.seloStatus = false

    if (custa.impresso_seguranca) {
      this.impressosSeguranca = true
    } else this.impressosSeguranca = false

    if (custa.selo_duplo) {
      this.seloDuplo = true
    } else this.seloDuplo = false
    custa = this.haldlerTipoRegistro(custa, tipoRegistro)
    this.custa = new Custa(custa)
  }

  get valor () {
    let valorAverbacao = 0
    let valorItensCusta = 0

    if (this.zerarCusta || !this.custa?.custa_id) {
      this._valor = 0
      return this._valor
    }

    if (!!this.ordem_servico_item_id) {
      this._valor = this.valorFinal
      return this._valor 
    }

    const custasAtivas = store.state.custa.custasAtivas
    if (!custasAtivas.length) {      
      console.log('Não foi possivel carregar as custas ativas')
      return 0
    }
    // Calcula conforme o valor da quantidade
    if (this.quantidade > 0 && this.custa.itens) {
      this.custa.itens.forEach(item => {
        valorItensCusta += item.valor
      })
      valorItensCusta = valorItensCusta * this.quantidade
    }
    // Calcula conforme a quantidade de averbações
    if (this.averbacao >= 0 && custasAtivas) {
      valorAverbacao = custasAtivas
        .find((custa) => custa.codigo === 12) // Custa com codigo 12 é referente ao campo de averbação
        .itens.map((item) => item.valor)
        .reduce((a, b) => a + b, 0)
        valorAverbacao = valorAverbacao * this.averbacao
    }
    this._valor = valorItensCusta + valorAverbacao
    return this._valor
  }
  set valor (value) {
    return
  }

  async getImpressosDisponiveis () {
    if (!this.impressosSeguranca || !this.custa) return 
    const {data} = await PapelSegurancaLoteItensService.getItensAtivos(this.custa?.impresso_seguranca)
    this.papeisDisponiveis = data
    return data
  }

  haldlerTipoRegistro (custa, tipo) {
    if (custa.codigo === 16 && tipo === 'obito') {
      custa.tipo_ato = 'AO'
      return custa
    }
    else if ((custa.codigo === 16  || custa.codigo === 19) && tipo === 'natimorto') {
      custa.tipo_ato = 'NT'
      return custa
    }
    return custa
  }

}

export default OrdemServicoItem